import { Switch } from "react-native-switch";
import { useDripsyTheme } from "dripsy";

import React from "react";

export interface UniSwitchProps {
  value: boolean;
  onValueChange: (value: boolean) => void;
  options?: {
    activeText?: string;
    inactiveText?: string;
    barHeight?: number;
    circleSize?: number;
    backgroundActive?: string;
    backgroundInactive?: string;
    circleActiveColor?: string;
    circleInactiveColor?: string;
  };
  disabled?: boolean;
}

export const UniSwitch = (props: UniSwitchProps) => {
  const { theme } = useDripsyTheme();

  const { value, options, onValueChange, disabled } = props;

  const {
    activeText = "",
    inactiveText = "",
    barHeight = 28,
    circleSize = 22,
    backgroundActive = disabled
      ? theme.colors.$disable
      : theme.colors.$backgroundInputActive,
    backgroundInactive = theme.colors.$disable,
    circleActiveColor = "#FFFFFF",
    circleInactiveColor = "#FFFFFF",
  } = options || {};

  return (
    <Switch
      disabled={disabled}
      value={value}
      onValueChange={onValueChange}
      circleSize={circleSize}
      barHeight={barHeight}
      circleBorderWidth={0}
      activeText={activeText}
      inActiveText={inactiveText}
      backgroundActive={disabled ? backgroundInactive : backgroundActive}
      backgroundInactive={backgroundInactive}
      circleActiveColor={disabled ? circleInactiveColor : circleActiveColor}
      circleInActiveColor={circleInactiveColor}
      switchLeftPx={2} // denominator for logic when sliding to TRUE position. Higher number = more space from RIGHT of the circle to END of the slider
      switchRightPx={2} // denominator for logic when sliding to FALSE position. Higher number = more space from LEFT of the circle to BEGINNING of the slider
      switchWidthMultiplier={2.5} // multiplied by the `circleSize` prop to calculate total width of the Switch
    />
  );
};
